module.exports = {"220282001":"明桦街道","220282002":"永吉街道","220282003":"胜利街道","220282004":"新华街道","220282005":"启新街道","220282100":"夹皮沟镇","220282101":"二道甸子镇","220282102":"红石砬子镇","220282103":"八道河子镇","220282104":"常山镇","220282105":"金沙镇","220282200":"桦郊乡","220282201":"横道河子乡","220282204":"公吉乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220282.json
// module id = 626
// module chunks = 0